// Deterministic, readable colour derived from a user's email. Because every
// peer hashes the same email to the same hue, a given user gets a consistent
// colour everywhere — remote cursors, and that user's own local caret. The
// lightness/saturation are tuned to be clearly visible as a caret on the white
// editor while still readable as a 30%-opacity selection highlight.
export const getColorForEmail = (email: string): string => {
  const normalizedEmail = email.trim().toLowerCase();
  let hash = 0;
  for (let i = 0; i < normalizedEmail.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    hash = normalizedEmail.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, 65%, 45%)`;
};

const generatedColors: string[] = [];

const componentToHex = (colorComponent: number) => {
  const hex = colorComponent.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
};

// eslint-disable-next-line import/prefer-default-export
export const generateUniqueColor = (dark = false) => {
  const minValue = dark ? 0 : 180;
  const maxValue = dark ? 100 : 255;

  let isUniqueColor = false;
  let colorCode = dark ? "#000000" : "#ffffff";

  while (!isUniqueColor) {
    const red =
      Math.floor(Math.random() * (maxValue - minValue + 1)) + minValue;
    const green =
      Math.floor(Math.random() * (maxValue - minValue + 1)) + minValue;
    const blue =
      Math.floor(Math.random() * (maxValue - minValue + 1)) + minValue;

    colorCode = `#${componentToHex(red)}${componentToHex(
      green,
    )}${componentToHex(blue)}`;

    if (!generatedColors.includes(colorCode)) {
      generatedColors.push(colorCode);
      isUniqueColor = true;
    }
  }

  return colorCode;
};
